import React, { Component } from "react";
import mainLogo from'../neurotoolkit.png';

class Footer extends Component {
	render() {
    return (
<div>
        <div class="spacer"></div>
        <div class="footer"></div>
        <div class="spacer"></div>
        <footer class="footer-2">
        <a href="http://neurotoolkit.com/about-us/">About us</a> | <a href="http://neurotoolkit.com/contact-us/">Contact us</a><br/>
The tools listed on this website do not substitute for the informed opinion of a licensed physician or other health care provider.<br/>
All scores should be re-checked. Please see our full <a href="http://neurotoolkit.com/terms-of-use/">Terms of Use</a>.<br/>
© neurotoolkit | 2018<br/>
</footer>
</div>
    );
}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js